export const structuringData = (data) => {
    const transformedBrands = data.map((brand) => ({
        value: brand,
        label: brand,
    }));
    return transformedBrands;
};
